import { Lookup } from '../lookup.interface';
export interface ReferralStatusLookup extends Lookup {
  caseDisplayValue: string;
}
export const ReferralStatuses: { [name: string]: ReferralStatusLookup } = {
  sent: { code: 'sent', displayValue: 'Sent', caseDisplayValue: 'CEC referred to Service Provider' },
  accepted: { code: 'accepted', displayValue: 'Accepted', caseDisplayValue: 'Accepted by Service Provider' },
  rejected: {
    code: 'rejected',
    displayValue: 'Rejected',
    caseDisplayValue: "Service Provider rejected CEC's referral",
  },
  assigned: { code: 'assigned', displayValue: 'Assigned', caseDisplayValue: 'Assigned to Service Provider' },
  completed: { code: 'completed', displayValue: 'Completed', caseDisplayValue: 'Completed CEIS service' },
  //prime referral statuses
  sentToPrime: {
    code: 'sentToPrime',
    displayValue: 'CEC referred to Prime',
    caseDisplayValue: 'CEC referred to Prime',
  },
  assignedToPrime: {
    code: 'assignedToPrime',
    displayValue: 'Assigned To Prime',
    caseDisplayValue: 'Assigned To Prime',
  },
  rejectedByPrime: {
    code: 'rejectedByPrime',
    displayValue: "Prime rejected CEC's referral",
    caseDisplayValue: "Prime rejected CEC's referral",
  },
  primeSentToSP: {
    code: 'primeSentToSP',
    displayValue: 'Prime referred to Service Provider',
    caseDisplayValue: 'Prime referred to Service Provider',
  },
  primeRejectedBySP: {
    code: 'primeRejectedBySP',
    displayValue: "Service Provider rejected Prime's referral",
    caseDisplayValue: "Service Provider rejected Prime's referral",
  },
};

export const ReferralInProgressStatusesForPrime: string[] = [
  ReferralStatuses.sent.code,
  ReferralStatuses.sentToPrime.code,
  ReferralStatuses.primeSentToSP.code,
  ReferralStatuses.accepted.code,
  ReferralStatuses.assigned.code,
];

export const ReferralInProgressStatusesForCEC: string[] = [
  ...ReferralInProgressStatusesForPrime,
  ReferralStatuses.assignedToPrime.code,
];

export const ReferralCompletedStatuses: string[] = [
  ReferralStatuses.completed.code,
  ReferralStatuses.rejected.code,
  ReferralStatuses.rejectedByPrime.code,
  ReferralStatuses.primeRejectedBySP.code,
];

//referrals awaiting the Service Provider (from CEC or from Prime)
export const ReferralSentToServiceProviderStatuses: string[] = [
  ReferralStatuses.sent.code,
  ReferralStatuses.primeSentToSP.code,
];

export const ReferralCECArchiveAllowedStatuses: string[] = [
  ...ReferralCompletedStatuses,
  ReferralStatuses.assignedToPrime.code,
  ReferralStatuses.primeSentToSP.code,
  ReferralStatuses.primeRejectedBySP.code,
  ReferralStatuses.accepted.code,
  ReferralStatuses.assigned.code,
];

export const ReferralPrimeArchiveAllowedStatuses: string[] = [
  ...ReferralCompletedStatuses,
  ReferralStatuses.sent.code,
  ReferralStatuses.sentToPrime.code,
  ReferralStatuses.assignedToPrime.code,
  ReferralStatuses.primeRejectedBySP.code,
  ReferralStatuses.accepted.code,
  ReferralStatuses.assigned.code,
];

// Referral statuses that indicate a Service Provider has responded (accepted or rejected)
// to a Prime's referral, allowing the Prime to unassign itself from the file (CSSCSM-9212).
export const ReferralPrimeUnassignAllowedStatuses: string[] = [
  ReferralStatuses.assigned.code,
  ReferralStatuses.completed.code,
  ReferralStatuses.primeRejectedBySP.code,
];
